import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';

import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Items from './pages/Items';
import CategoriesAndBrands from './pages/CategoriesAndBrands';
import POS from './pages/POS';
import Reports from './pages/Reports';
import Receipts from './pages/Receipts';
import Debtors from './pages/Debtors';
import AdminPanel from './pages/AdminPanel';
import ManageUsers from './pages/ManageUsers';
import PublicMarket from './pages/PublicMarket';
import PrivateRoute from './components/PrivateRoute';
import RoleBasedRedirect from './components/RoleBasedRedirect';
import OfflineIndicator from './components/OfflineIndicator';
import { AuthProvider } from './context/AuthContext';

function App() {
  return (
    <Suspense fallback={<div className="loading">Loading...</div>}>
      <AuthProvider>
        <Router>
          <div className="App">
            <OfflineIndicator />
            <ToastContainer position="top-right" autoClose={3000} />
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/market/:username" element={<PublicMarket />} />
              <Route
                path="/dashboard"
                element={
                  <PrivateRoute requiredRole={['owner', 'seller']}>
                    <Dashboard />
                  </PrivateRoute>
                }
              />
              <Route
                path="/items"
                element={
                  <PrivateRoute requiredRole={['owner']}>
                    <Items />
                  </PrivateRoute>
                }
              />
              <Route
                path="/categories-brands"
                element={
                  <PrivateRoute requiredRole={['owner']}>
                    <CategoriesAndBrands />
                  </PrivateRoute>
                }
              />
              <Route
                path="/pos"
                element={
                  <PrivateRoute requiredRole={['owner', 'seller']}>
                    <POS />
                  </PrivateRoute>
                }
              />
              <Route
                path="/reports"
                element={
                  <PrivateRoute requiredRole={['owner']}>
                    <Reports />
                  </PrivateRoute>
                }
              />
              <Route
                path="/receipts"
                element={
                  <PrivateRoute requiredRole={['owner']}>
                    <Receipts />
                  </PrivateRoute>
                }
              />
              <Route
                path="/debtors"
                element={
                  <PrivateRoute requiredRole={['owner']}>
                    <Debtors />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin-panel"
                element={
                  <PrivateRoute requiredRole={['superadmin', 'admin']}>
                    <AdminPanel />
                  </PrivateRoute>
                }
              />
              <Route
                path="/manage-users"
                element={
                  <PrivateRoute requiredRole={['superadmin', 'admin']}>
                    <ManageUsers />
                  </PrivateRoute>
                }
              />
              <Route path="/" element={<RoleBasedRedirect />} />
            </Routes>
          </div>
        </Router>
      </AuthProvider>
    </Suspense>
  );
}

export default App;
